export const pushCurrentPageToDataLayer = (page) => {
  const dataLayerData = {
    event: 'VirtualPageview',
    page: {
      currency: process.env.GATSBY_CURRENCY,
      currentPage: page.title,
    },
  };

  if (typeof dataLayer === 'undefined') {
    return;
  }

  if (typeof ga !== 'undefined') {
    ga('create', process.env.GOOGLE_ANALYTICS_ID, 'auto');
    ga('set', 'dimension13', process.env.GATSBY_BRANCH);
  }

  dataLayer.push(dataLayerData);
};
